import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";

export default function PraposedSuccessful() {
  const { resetAllFields, setManageActivecontestroute, setManageAppliedjobroute , setManageAppliedprojectroute} =
    useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    LoadCSSforfirstTime(path);
    resetAllFields();
  }, [path]);

  const navigatepagebasedontype = () => {
    if (state?.type == "project") {
      setManageAppliedprojectroute("ProjectProposal")
      if (state?.post_id || state?.response?.post_id) {
        navigate(
          `/${lan}/dashboard/managework/projects/applied/${state?.post_id || state?.response?.post_id}`,
        );
      } else {
        navigate(`/${lan}/dashboard/managework/projects`);
      }
    } else if (state?.type == "job") {
      setManageAppliedjobroute("MyProposal")
      if (state?.post_id || state?.response?.post_id) {
        navigate(
          `/${lan}/dashboard/managework/jobs/applied/${state?.post_id ||  state?.response?.post_id}`,
        );
      } else {
        navigate(`/${lan}/dashboard/managework/jobs`);
      }
    } else if (state?.type == "contest") {
      setManageActivecontestroute("Entries");
      navigate(
        `/${lan}/dashboard/managework/contests/active/${state?.response?.post_id}`,
      );
    } else {
      return null;
    }
  };

  return (
    <div className="col-md-8 mx-auto signuppage">
      <div className=" text-center">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/tick-back.svg`}
          alt=""
        />
        <h1>
          Congratulations! Your&nbsp;
          {state?.type == "contest" ? "Entry" : "Proposal"} has been submitted successfully.
        </h1>
      </div>
      <div className="visit">
        <button onClick={() => navigatepagebasedontype()} className="btn">
          View {state?.type == "contest" ? "Entry" : "Proposal"}
        </button>
      </div>
    </div>
  );
}
